import { css } from "styled-components";
import { boldTypographyMixin, textUppercaseMixin } from "../../shared/mixins/typography";
import { mediaQueries } from "./breakpoints";
const headingTextFontMixin = css `
  text-wrap: balance;
  word-break: break-word;
  font-family: "Riot Sans", sans-serif;

  &:lang(ja-jp),
  &:lang(ko-kr),
  &:lang(th-th),
  &:lang(zh-tw) {
    font-family: "Noto Sans", sans-serif;
  }

  &:lang(ru-ru),
  &:lang(vi-vn) {
    font-family: Inter, sans-serif;
  }
`;
const bodyTextFontMixin = css `
  font-family: Inter, sans-serif;
  word-break: break-word;

  &:lang(ja-jp),
  &:lang(ko-kr),
  &:lang(th-th),
  &:lang(zh-tw) {
    font-family: "Noto Sans", sans-serif;
  }
`;
export const body1TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 28px;
  line-height: 36px;

  ${mediaQueries.tabletDown} {
    font-size: 22px;
    line-height: 28px;
  }

  ${mediaQueries.mobileDown} {
    font-weight: 400;
    font-size: 18px;
    line-height: 22px;
  }
`;
export const body2TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 22px;
  line-height: 28px;

  ${mediaQueries.tabletDown} {
    font-size: 18px;
    line-height: 22px;
  }

  ${mediaQueries.mobileDown} {
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
  }
`;
export const body3TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.03em;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 24px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 14px;
    line-height: 22px;
  }
`;
export const body4TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 16px;
  line-height: 24px;
  ${mediaQueries.tabletDown} {
    font-size: 14px;
    line-height: 22px;
  }
  ${mediaQueries.mobileDown} {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
  }
`;
export const body5TypographyMixin = css `
  ${bodyTextFontMixin}
  font-size: 14px;
  line-height: 22px;
  ${mediaQueries.tabletDown} {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }
  ${mediaQueries.mobileDown} {
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
  }
`;
export const display1TypographyMixin = css `
  ${boldTypographyMixin}
  ${textUppercaseMixin}
  ${headingTextFontMixin}
    font-size: 250px;
  line-height: 224px;
  ${mediaQueries.tabletDown} {
    font-size: 115px;
    line-height: 104px;
  }
  ${mediaQueries.mobileDown} {
    letter-spacing: -0.02em;
    font-size: 60px;
    line-height: 56px;
  }
`;
export const display2TypographyMixin = css `
  ${boldTypographyMixin}
  ${textUppercaseMixin}
  ${headingTextFontMixin}
    font-size: 150px;
  line-height: 132px;
  ${mediaQueries.tabletDown} {
    font-size: 64px;
    line-height: 58px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 56px;
    line-height: 50px;
    letter-spacing: -0.02em;
  }
`;
export const display3TypographyMixin = css `
  ${boldTypographyMixin}
  ${textUppercaseMixin}
  ${headingTextFontMixin}
    font-size: 80px;
  line-height: 68px;
  ${mediaQueries.tabletDown} {
    font-size: 48px;
    line-height: 46px;
  }

  ${mediaQueries.mobileDown} {
    font-size: 28px;
    line-height: 30px;
    letter-spacing: -0.02em;
  }
`;
export const display4TypographyMixin = css `
  ${boldTypographyMixin}
  ${textUppercaseMixin}
  ${headingTextFontMixin}
    font-size: 64px;
  line-height: 60px;
  ${mediaQueries.tabletDown} {
    font-size: 32px;
    line-height: 34px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.02em;
  }
`;
export const display5TypographyMixin = css `
  ${boldTypographyMixin}
  ${textUppercaseMixin}
  ${headingTextFontMixin}
    font-size: 48px;
  line-height: 46px;
  ${mediaQueries.tabletDown} {
    font-size: 42px;
    line-height: 42px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 32px;
    line-height: 34px;
    letter-spacing: -0.02em;
  }
`;
export const display6TypographyMixin = css `
  ${boldTypographyMixin}
  ${textUppercaseMixin}
  ${headingTextFontMixin}

    font-size: 32px;
  line-height: 30px;
  ${mediaQueries.tabletDown} {
    font-size: 20px;
    line-height: 20px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 24px;
    line-height: 24px;
    letter-spacing: -0.03em;
  }
`;
export const display7TypographyMixin = css `
  ${boldTypographyMixin}
  ${textUppercaseMixin}
  ${headingTextFontMixin}
    font-size: 24px;
  line-height: 22px;
  ${mediaQueries.tabletDown} {
    font-size: 20px;
    line-height: 20px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 18px;
    line-height: 20px;
    letter-spacing: -0.03em;
  }
`;
export const display8TypographyMixin = css `
  ${boldTypographyMixin}
  ${bodyTextFontMixin}
    font-size: 20px;
  line-height: 24px;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 22px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
  }
`;
export const display9TypographyMixin = css `
  ${boldTypographyMixin}
  ${bodyTextFontMixin}
    font-size: 20px;
  line-height: 24px;
  ${mediaQueries.tabletDown} {
    font-size: 16px;
    line-height: 22px;
  }
  ${mediaQueries.mobileDown} {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: -0.02em;
  }
`;
export const eyebrowTypographyMixin = css `
  ${boldTypographyMixin}
  ${textUppercaseMixin}
  ${bodyTextFontMixin}
    font-size: 14px;
  line-height: 14px;
  ${mediaQueries.mobileDown} {
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -0.01em;
  }
`;
export const tagTypographyMixin = css `
  ${textUppercaseMixin}
  ${bodyTextFontMixin}
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
`;
export const labelTypographyMixin = css `
  ${bodyTextFontMixin}
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
`;
export const textLinkTypographyMixin = css `
  ${boldTypographyMixin}
  ${bodyTextFontMixin}
  font-size: 16px;
  line-height: 22px;
  letter-spacing: -0.01em;
  ${mediaQueries.mobileDown} {
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
  }
`;
export const ctaTypographyMixin = [];
//# sourceMappingURL=typography.js.map